/// <amd-module name="Core/Medius.Core.Web/Scripts/components/quickSearch/services/windowService"/>

export function navigateTo(href: string) {
    window.location.href = href;
}